/**
 * Laurel V2.4 — AI Portfolio Strategist for Founders
 * Modular React + TypeScript architecture (Cloudflare Pages)
 *
 * This file serves as the orchestration layer, composing modular components
 * into the complete Laurel site experience.
 *
 * Design system managed in tailwind.config.js
 * Data generation utilities in src/utils/chartGenerators.ts
 * Shared components in src/components/shared/
 * Section components in src/components/Laurel/
 */

import { TopNav } from './components/Laurel/TopNav'
import { Hero } from './components/Laurel/Hero'
import { TrustBar } from './components/Laurel/TrustBar'
import { InsightsFeed } from './components/Laurel/InsightsFeed'
import { IntegrationsPanel } from './components/Laurel/IntegrationsPanel'
import { InvestorFitPanel } from './components/Laurel/InvestorFitPanel'
import { PortfolioHealth } from './components/Laurel/PortfolioHealth'
import { Pricing } from './components/Laurel/Pricing'
import { FAQ } from './components/Laurel/FAQ'
import { Footer } from './components/Laurel/Footer'
import { runChartGeneratorTests } from './utils/chartGenerators'

// Run smoke tests in development to catch regressions early
if (import.meta.env.DEV) {
  runChartGeneratorTests()
}

export default function LaurelSite() {
  return (
    <div className="min-h-screen w-full bg-canvas text-ink">
      <TopNav />
      <Hero />
      <TrustBar />
      <main className="mx-auto max-w-7xl px-4 md:px-6 pb-16">
        <div className="grid gap-6 lg:grid-cols-3">
          <IntegrationsPanel />
          <PortfolioHealth />
        </div>
        <div className="mt-6">
          <InvestorFitPanel />
        </div>
        <div className="mt-6">
          <InsightsFeed />
        </div>
      </main>
      <Pricing />
      <FAQ />
      <Footer />
    </div>
  )
}
